module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-13.438a179a.png";